import ClientBindTransportVehicleInfoGroupModal from './client-bind-transport-vehicle-info-group-modal.vue'
export default ClientBindTransportVehicleInfoGroupModal
